import { render, staticRenderFns } from "./manualFaceCheck.vue?vue&type=template&id=3e078b1a&scoped=true&"
import script from "./manualFaceCheck.vue?vue&type=script&lang=js&"
export * from "./manualFaceCheck.vue?vue&type=script&lang=js&"
import style0 from "./manualFaceCheck.vue?vue&type=style&index=0&id=3e078b1a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e078b1a",
  null
  
)

export default component.exports